import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../Layouts/Loader";
import { getEventDetails, getEventQuestions, openAllBets, uncallAllBetsAndOpenEvent, prepayEvent, getEventSettleups, getEventSummaryData, deleteEvent, toggleSocialIncentive, resendSplitPotNotices } from "../../../Services/Events";
import { generateEventSummaryPDF } from "../../../utils/eventSummaryPdf";
import EventDetailsCard from "../Components/EventDetailsCard";
import Question from "../Components/Question";
import UserBets from "./Components/UserBets";
import Participants from "./Components/Participants";
import SettleupsTable from "./Components/SettleupsTable";

const Details = () => {
  const param = useParams();
  const navigate = useNavigate();
  const [eventDetails, setEventDetails] = useState();
  const [eventQuestions, setEventQuestions] = useState();
  const [settleups, setSettleups] = useState();
  // Bumped after a participant removal so UserBets refetches (their bets are gone)
  const [betsRefreshKey, setBetsRefreshKey] = useState(0);

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = () => {
    getEventDetails(param.eventid)
      .then((res) => {
        console.log(res);
        setEventDetails(res.data.data.responseData[0]);
        getEventSettleups(param.eventid)
          .then((sres) => {
            setSettleups(sres.data);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));

    getEventQuestions(param.eventid)
      .then((res) => {
        console.log(res);
        setEventQuestions(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleOpenAllBets = () => {
    if (window.confirm("Are you sure you want to open all bets?")) {
      openAllBets(param.eventid).then((res) => {
        console.log(res);
      })
      .catch((err) => console.log(err));
    }
  };

  const handleUncallAllBetsAndOpenEvent = () => {
    if (window.confirm("Are you sure you want to uncall all bets and open the event?")) {
      uncallAllBetsAndOpenEvent(param.eventid).then((res) => {
        console.log(res);
      })
      .catch((err) => console.log(err));
    }
  };

  const handlePrepayEvent = () => {
    if (window.confirm("Are you sure you want to prepay this event?")) {
      prepayEvent(param.eventid)
        .then((res) => {
          console.log(res);
          // Refresh event details to show updated prepaid status
          getDetails();
        })
        .catch((err) => console.log(err));
    }
  };

  const handleDownloadEventSummary = () => {
    getEventSummaryData(param.eventid)
      .then(async (response) => {
        if (response.data.status === 1 && response.data.data) {
          // Debug: Log received data sizes
          const data = response.data.data;
          console.log('Received summary data:', {
            gameTapeCount: data.gameTape?.length || 0,
            witnessesCount: data.witnesses?.length || 0,
            totalGuests: data.vitals?.totalGuests || 0,
            appType: data.appType
          });
          
          try {
            // Generate PDF client-side
            console.log('Starting PDF generation...');
            const doc = await generateEventSummaryPDF(data);
            console.log('PDF generated successfully, saving...');
            doc.save(`Official_Betting_Record_${param.eventid}.pdf`);
            console.log('PDF saved successfully');
          } catch (pdfError) {
            console.error('PDF generation failed:', pdfError);
            console.error('Error details:', pdfError.message);
            console.error('Stack trace:', pdfError.stack);
            alert(`Failed to generate PDF: ${pdfError.message || 'Unknown error'}. Check console for details.`);
          }
        } else {
          console.error('Invalid response from server:', response.data);
          alert('Failed to generate event summary. Please try again.');
        }
      })
      .catch((err) => {
        console.error('Error fetching event summary data:', err);
        console.error('Error details:', err.message);
        alert(`Failed to download event summary: ${err.message || 'Unknown error'}. Please try again.`);
      });
  };

  const handleToggleSocialIncentive = () => {
    const current = eventDetails?.social_incentive_enabled === false ? "Disabled" : "Enabled";
    const next = eventDetails?.social_incentive_enabled === false ? "enable" : "disable";
    if (window.confirm(`Social incentive is currently ${current}. Are you sure you want to ${next} it?`)) {
      toggleSocialIncentive(param.eventid)
        .then((res) => {
          if (res.data.status === 1) {
            getDetails();
          } else {
            alert('Failed to toggle social incentive: ' + (res.data.message || 'Unknown error'));
          }
        })
        .catch((err) => {
          console.error('Error toggling social incentive:', err);
          alert('Failed to toggle social incentive. Please try again.');
        });
    }
  };

  const handleResendSplitPotNotices = () => {
    if (!window.confirm("Send the Split the Pot winner email to any winner who hasn't received it yet? Winners already emailed are skipped.")) return;
    resendSplitPotNotices(param.eventid)
      .then((res) => {
        const d = res.data?.data || {};
        const winners = (d.winners || []).map((w) => `${w.name} (#${w.user_id})${w.is_creator ? " - creator, skipped" : ""}${w.already_notified ? " - already emailed" : ""}`).join("\n") || "none";
        alert(`${res.data?.message || "Done"}\n\nWinners:\n${winners}\nShare: ${((d.shareCents || 0) / 100).toFixed(2)}`);
      })
      .catch((err) => {
        alert("Failed: " + (err.response?.data?.message || err.message || "Unknown error"));
      });
  };

  const handleDeleteEvent = () => {
    const confirmMessage = `Are you sure you want to delete this event?\n\nThis will:\n- Remove all bets, participants, and questions\n- Mark the event as deleted\n- Block access via deeplinks\n\nThis action cannot be undone.`;
    
    if (window.confirm(confirmMessage)) {
      deleteEvent(param.eventid)
        .then((res) => {
          if (res.data.status === 1) {
            alert('Event deleted successfully');
            getDetails(); // Refresh to show deleted status
          } else {
            alert('Failed to delete event: ' + (res.data.message || 'Unknown error'));
          }
        })
        .catch((err) => {
          console.error('Error deleting event:', err);
          alert('Failed to delete event: ' + (err.response?.data?.message || 'Please try again.'));
        });
    }
  };

  return (
    <>
      <div class="row">
        <div class="col">
          <nav aria-label="breadcrumb" class="bg-light rounded-3 p-3 mb-4">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <Link to={"/events"} className="breadcrump-link">
                  Events
                </Link>
              </li>
              <li class="breadcrumb-item">Details</li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="d-flex justify-content-between mb-4">
        <div className="page_header">
          <h2>Event Details</h2>
        </div>
        <button
          type="button"
          onClick={() => navigate(`/events/payout/${param.eventid}`)}
          className="btn m-1"
          style={{ backgroundColor: "#df6053", color: "white" }}
        >
          View Payouts
        </button>
        <button
          type="button"
          onClick={handleDownloadEventSummary}
          className="btn m-1"
          style={{ backgroundColor: "#df6053", color: "white" }}
          disabled={eventDetails?.status !== 'Closed' && eventDetails?.status !== 'Completed'}
        >
          Download PDF Summary
        </button>
        <button
          type="button"
          onClick={handlePrepayEvent}
          className="btn m-1"
          style={{ backgroundColor: "#28a745", color: "white" }}
          disabled={eventDetails?.is_prepaid}
        >
          Prepay Event
        </button>
        {eventDetails?.app_type === 1 && (
          <button
            type="button"
            onClick={handleToggleSocialIncentive}
            className="btn m-1"
            style={{ backgroundColor: eventDetails?.social_incentive_enabled === false ? "#6c757d" : "#17a2b8", color: "white" }}
          >
            {eventDetails?.social_incentive_enabled === false ? "Enable Social Incentive" : "Disable Social Incentive"}
          </button>
        )}
        {eventDetails?.is_split_pot && (eventDetails?.status === "Closed" || eventDetails?.status === "Completed") && (
          <button
            type="button"
            onClick={handleResendSplitPotNotices}
            className="btn m-1"
            style={{ backgroundColor: "#6f42c1", color: "white" }}
          >
            Resend Split the Pot Emails
          </button>
        )}
        <button
          type="button"
          onClick={() => handleUncallAllBetsAndOpenEvent()}
          className="btn m-1"
          style={{ backgroundColor: "#FF0000", color: "white" }}
        >
          Uncall All Bets + Open Wedding
        </button>
        <button
          type="button"
          onClick={() => handleOpenAllBets()}
          className="btn m-1"
          style={{ backgroundColor: "#FF0000", color: "white" }}
        >
          Open All Bets
        </button>
        <button
          type="button"
          onClick={handleDeleteEvent}
          className="btn m-1"
          style={{ backgroundColor: "#dc3545", color: "white" }}
          disabled={eventDetails?.deleted}
        >
          {eventDetails?.deleted ? "Event Deleted" : "Delete Event"}
        </button>
      </div>

      {eventQuestions?.status ? (
        <>
          {eventDetails ? (
            <EventDetailsCard Details={eventDetails} />
          ) : (
            <Loader />
          )}
          <div className="page_header ">
            <h2>Event Questions</h2>
          </div>
          {eventQuestions.data.totalRecords ? (
            <div className="mb-4 p-3">
              {eventQuestions.data.responseData.map((question, index) => (
                <Question question={question} index={index} />
              ))}
            </div>
          ) : (
            <div className="card mb-4">
              <h5 className="text-center p-5">Questions does not exist!</h5>
            </div>
          )}
          
          <>
            <div className="page_header ">
              <h2>Settleups</h2>
            </div>
            <div className="card mb-4">
              {settleups?.data?.totalRecords ? (
                <div className="card-body ">
                  <SettleupsTable settleupsData={settleups.data.responseData} />
                </div>
              ) : (
                <h5 className="text-center p-5">No settleups found!</h5>
              )}
            </div>
          </>
          
          <Participants
            eventId={param.eventid}
            onParticipantRemoved={() => {
              getDetails();
              setBetsRefreshKey((k) => k + 1);
            }}
          />
          <UserBets key={betsRefreshKey} eventId={param.eventid} />
        </>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default Details;
